import { initialScheduleState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { ScheduleState } from "types/Schedule";
import { ScheduleConstants } from "constants/constants";

export const scheduleReducer = (
  state = initialScheduleState,
  action: ReducersInterfaceAction,
): ScheduleState => {
  switch (action.type) {
    case ScheduleConstants.SCHEDULE_TABLE_GET_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        dateList: action.payload?.dateList,
        planList: action.payload?.planList,
        dataList: action.payload?.dataList,
      };
    case ScheduleConstants.SCHEDULE_GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        loadingData: false,
        userList: action.payload,
      };

    case ScheduleConstants.SCHEDULE_UPDATE_SCHEDULE_REPORT:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload,
      };
    case ScheduleConstants.SCHEDULE_UPDATE_RECORD_ROLE:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload,
      };
    case ScheduleConstants.SCHEDULE_TABLE_GET_DATA_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case ScheduleConstants.SCHEDULE_TABLE_GET_DATA_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case ScheduleConstants.SCHEDULE_UPDATE_USER_ID_LIST:
      return {
        ...state,
        loadingData: false,
        idListForSMS: action.payload,
      };
    case ScheduleConstants.SCHEDULE_UPDATE_COPY_ID_LIST:
      return {
        ...state,
        idListForCopy: action.payload,
      };
    case ScheduleConstants.SCHEDULE_UPDATE_DELETE_ID_LIST:
      return {
        ...state,
        idListForDelete: action.payload,
      };
    case ScheduleConstants.SCHEDULE_SET_COPY_MODE:
      return {
        ...state,
        mode: "copy",
        reportCopy: action.payload,
      };
    case ScheduleConstants.SCHEDULE_COPY_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload,
        mode: "manual",
        reportCopy: null,
        idListForCopy: [],
      };
    case ScheduleConstants.SCHEDULE_MULPIPLE_DELETE_SCHEDULE_REPORT:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload,
        mode: "manual",
        reportCopy: null,
        idListForDelete: [],
      };
    case ScheduleConstants.SCHEDULE_SET_MANUAL_MODE:
      return {
        ...state,
        mode: "manual",
        reportCopy: null,
        idListForDelete: [],
        idListForCopy: [],
      };
    case ScheduleConstants.SCHEDULE_SET_DELETE_MODE:
      return {
        ...state,
        mode: "delete",
        reportCopy: null,
      };
    case ScheduleConstants.SCHEDULE_SET_FILTERS:
      return {
        ...state,
        scheduleFilters: action.payload,
      };
    case ScheduleConstants.SCHEDULE_USERS_NOTIFY_SUCCESS:
      return {
        ...state,
        idListForSMS: [],
      };
    case ScheduleConstants.SCHEDULE_PUBLISH_SCHEDULES_SUCCESS:
      return {
        ...state,
        idListForSMS: [],
        dataList: action.payload,
      };
    default:
      return state;
  }
};
